<app-breadcrumb [title]="'Gestión de competencias por cargo'" [items]="['Pesv']"
    [active_item]="'Gestión de competencias'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <i class="icofont icofont-users-alt-4 me-2"></i>
                <h5 class="mb-0"><strong>COMPETENCIAS POR CARGO</strong></h5>
            </div>


        </div>

        <div class="card-body">

            <div *ngIf="cargandoListado || cargandoCatalogos" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2 mb-0">Cargando información...</p>
            </div>

            <div class="row mb-3 align-items-center" *ngIf="!cargandoListado && !cargandoCatalogos">
                <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                        <option [ngValue]="null">Todos</option>
                        <option [ngValue]="1">Con competencias activas</option>
                        <option [ngValue]="0">Sin competencias activas</option>
                    </select>
                </div>
                <div class="col-md-4 ms-auto">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Buscar por cargo o competencia..."
                            [(ngModel)]="filtro" (input)="aplicarFiltro()" />
                        <span class="input-group-text">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="!cargandoListado && !cargandoCatalogos" class="table-responsive mt-2">
                <ng-container>
                    <table id="tblGestionCompetencia" class="table table-bordered table-hover align-middle">
                        <thead class="bg-primary text-white">
                            <tr>
                                <th class="text-center" style="width: 20%;">CARGO</th>
                                <th class="text-center">COMPETENCIAS ASIGNADAS</th>
                                <th class="text-center" style="width: 10%;">ESTADO</th>
                                <th class="text-center" style="width: 12%;">ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let fila of filasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                <td class="text-center text-black">{{ fila.cargoNombre }}</td>
                                <td>
                                    <div class="d-flex flex-wrap gap-1"
                                        *ngIf="fila.competenciasActivas.length > 0; else sinCompetencias">
                                        <span class="badge bg-secondary me-1 mb-1"
                                            *ngFor="let c of fila.competenciasActivas | slice:0:3">
                                            {{ c.descripcion }}
                                        </span>

                                        <span *ngIf="fila.competenciasActivas.length > 3" class="badge bg-dark">
                                            +{{ fila.competenciasActivas.length - 3 }}
                                        </span>
                                    </div>

                                    <ng-template #sinCompetencias>
                                        <span class="text-secondary small">Sin competencias activas</span>
                                    </ng-template>
                                </td>
                                <td class="text-center">
                                    <span class="badge rounded-pill"
                                        [ngClass]="fila.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                        {{ fila.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center gap-1">
                                        <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                            ngbTooltip="Editar" (click)="abrirModalEditar(modalGestion, fila)">
                                            <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                            *ngIf="fila.estado === 1" ngbTooltip="Inactivar"
                                            (click)="cambiarEstado(fila, 0)">
                                            <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                            *ngIf="fila.estado !== 1" ngbTooltip="Activar"
                                            (click)="cambiarEstado(fila, 1)">
                                            <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay asignaciones registradas.</div>
                </ng-template>
            </div>

                                <div class="d-flex justify-content-between align-items-center mt-4">
                        <div class="d-flex align-items-center">
                            <label for="pageSizeGestion" class="me-2">Mostrar:</label>
                            <select id="pageSizeGestion" class="form-select w-auto" [(ngModel)]="pageSize"
                                (change)="page = 1">
                                <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                            </select>
                            <span class="ms-2">registros por página</span>
                        </div>

                        <div class="text-center flex-grow-1">
                            Total Registros:
                            <a class="badge badge-primary"><b>{{ filasFiltradas?.length || 0 }}</b></a>
                        </div>

                        <div class="text-end paginador-personalizado">
                            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                                [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                        </div>
                    </div>

                    <div class="mt-4">
                        <div class="btn-showcase text-center">
                            <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                                (click)="exportarExcel('tblGestionCompetencia','listado_competencias_por_cargo')">
                                <i class="icofont icofont-file-excel"></i> EXCEL
                            </button>
                            <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                                (click)="exportToPDF('tblGestionCompetencia','listado_competencias_por_cargo','Competencias por cargo')">
                                <i class="icofont icofont-file-pdf"></i> PDF
                            </button>
                            <button class="btn btn-outline-primary-2x" type="button"
                                (click)="abrirModalCrear(modalGestion)">
                                <i class="icofont icofont-plus me-1"></i> Nueva asignación
                            </button>
                        </div>
                    </div>
                    
        </div>
    </div>
</div>

<!-- Modal Crear / Editar -->
<ng-template #modalGestion let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont" [ngClass]="modoEdicion ? 'icofont-edit' : 'icofont-plus'" style="margin-right: 8px;"></i>
            {{ modoEdicion ? 'Editar competencias del cargo' : 'Asignar competencias a un cargo' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <form [formGroup]="gestionForm" novalidate>
        <div class="modal-body">

            <div class="mb-3">
                <label class="form-label text-black">
                    Cargo <span class="text-danger">*</span>
                </label>
                <ng-select [items]="cargos" bindLabel="nombre" bindValue="id" formControlName="cargo"
                    placeholder="Seleccione el cargo..."
                    [class.is-invalid]="gestionForm.get('cargo')?.invalid && gestionForm.get('cargo')?.touched">
                </ng-select>
                <small class="text-secondary" *ngIf="modoEdicion">
                    El cargo no se puede modificar en edición; solo sus competencias asignadas.
                </small>
            </div>

            <div class="mb-3">
                <label class="form-label text-black">
                    Competencias <span class="text-danger">*</span>
                </label>
                <ng-select [items]="competencias" bindLabel="descripcion" bindValue="id" formControlName="competencias"
                    [multiple]="true" placeholder="Seleccione una o varias competencias..."
                    [class.is-invalid]="gestionForm.get('competencias')?.invalid && gestionForm.get('competencias')?.touched">
                </ng-select>
            </div>

        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
                [disabled]="guardando">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="guardar(modal)" [disabled]="guardando">
                <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Guardar cambios' : 'Guardar' }}
                </span>
                <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                </span>
            </button>
        </div>
    </form>
</ng-template>